import { render, staticRenderFns } from "./GoodNews.vue?vue&type=template&id=b08a8b54&scoped=true&"
import script from "./GoodNews.vue?vue&type=script&lang=js&"
export * from "./GoodNews.vue?vue&type=script&lang=js&"
import style0 from "./GoodNews.vue?vue&type=style&index=0&id=b08a8b54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08a8b54",
  null
  
)

export default component.exports